import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FiEdit, FiTrash } from 'react-icons/fi';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { AiOutlineCloseCircle } from 'react-icons/ai';


import Layout from '../../components/Layout';
import { Container, List } from './styles';
import Table from '../../components/Table';
import Pagination from '../../components/Pagination';

import api from '../../services/api';

import { User } from '../../interfaces/User';
import { useToast } from '../../hooks/Toast';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { useAuth } from '../../hooks/Auth';

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [filteredAttr, setFilteredAttr] = useState('');
  const [loadingData, setLoadingData] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState<boolean>(false);

  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();

  useEffect(() => {
    setLoadingData(true);
    api
      .get('users', {
        params: {
          search: filteredAttr,
          page: currentPage,
        },
      })
      .then(response => {
        setUsers(response.data.items);
        setLoadingData(false);
        setTotalPages(response.data.last_page);
      });
  }, [filteredAttr, currentPage, refresh]);

  const handleEdit = useCallback(
    user => {
      history.push(`${process.env.PUBLIC_URL}/usuarios/${user.id}`);
    },
    [history],
  );

  let timeout: any;
  const handleSearchInput = useCallback((value) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setFilteredAttr(value);
    }, 1000);
  }, [timeout]);

  const handleDelete = useCallback((item: User) => {
    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Confirmar exclusão</h1>
              <p>Gostaria de deletar o usuário {item.name}? (Está ação irreversível)</p>
              <button onClick={onClose}>Não</button>
              <button
                onClick={async () => {
                  await api.delete(
                    `users/${item.id}`
                  );

                  addToast({
                    type: 'success',
                    title: 'Usuário deletado com sucesso!',
                  });
                  setRefresh(!refresh);

                  onClose();
                }}
              >
                Sim, deletar!
              </button>
            </div>
          );
        },
      });
    } catch (err) {
      console.error('err', err);
      addToast({
        type: 'error',
        title: 'Falha na requisição',
        description:
          'Ocorreu um erro ao deletar os dados, atualize a página e tente novamente.',
      });
    }
  }, []);

  return (
    <Layout>
      <Container>
        <div className="breadcrumb">
          <h1>MDS &gt; Usuários</h1>


        </div>

        <List>
          <Table>
            <div className="top">
              <div className="filter">
                <input
                  type="text"
                  name="search"
                  placeholder="Pesquisar por nome ou email"
                  onChange={event => handleSearchInput(event.target.value)}
                  className="filter-input"
                />
              </div>
              <button
                type="button"
                className="new-btn"
                onClick={() =>
                  history.push(`${process.env.PUBLIC_URL}/usuarios/novo`)
                }
              >
                Novo
              </button>
            </div>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Telefone</th>
                    {/* <th>Permissão</th> */}
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingData ? (
                    <tr>
                      <td colSpan={4}>
                        Carregando usuários...
                      </td>
                    </tr>
                  ) : (
                    <>
                      {
                        users.length > 0 ?
                          users.map(item => (
                            <tr key={item.id.toString()}>
                              <td>{item.name}</td>
                              <td>{item.email}</td>
                              <td>{item.phone ? item.phone : "Não informado"}</td>
                              {/* <td className="icon">{item.role.name}</td> */}
                              <td>
                                <button
                                  type="button"
                                  onClick={() => handleEdit(item)}
                                >
                                  <FiEdit />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDelete(item)}
                                  disabled={item.id === user.id}
                                >
                                  <FiTrash />
                                </button>
                              </td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={4}>
                                Nenhum resultado encontrado
                              </td>
                            </tr>
                          )
                      }
                    </>
                  )}
                </tbody>
              </table>
              <Pagination
                pages={totalPages}
                currentPage={currentPage}
                setPage={p => setCurrentPage(p)}
              />
            </div>
          </Table>
        </List>


      </Container>
    </Layout>
  );
};

export default Users;
